import AttestationDef from '@/generated/classes/AttestationDef';
export default class AttestationDefExtend extends AttestationDef {
  constructor() {
    super();
  }
}
